export default __webpack_public_path__ + "static/media/juego rio 2-21.e057a453.png";